import React from "react";
import PropTypes from "prop-types";
import { Alert, Button } from "antd";
import "./TeamInvitationCard.scss";

function TeamInvitationCard({ team, isJoined, onJoin, disabled, errorMessage }) {
  const teamName = team.name || "Unknown Team";
  const managerName = team.teamManagerName;

  if (isJoined) {
    return (
      <div className="team-invitation-wrapper">
        <div className="team-invitation-card team-invitation-card--joined">
          <div className="team-invitation-card__content">
            <div className="team-invitation-card__title">
              <span className="team-invitation-card__checkmark">&#10003;</span>
              You have joined {teamName}
            </div>
            <div className="team-invitation-card__description">
              {managerName ? `Team Manager: ${managerName}. ` : ""}Once your registration is submitted, you will appear
              on the team roster.
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="team-invitation-wrapper">
      <div className="team-invitation-card team-invitation-card--pending">
        <div className="team-invitation-card__content">
          <div className="team-invitation-card__title">You have been invited to join {teamName}</div>
          {managerName && <div className="team-invitation-card__manager">Team Manager: {managerName}</div>}
        </div>
        <div className="team-invitation-card__action">
          <Button
            type="primary"
            className="team-invitation-card__join-button"
            onClick={() => onJoin(team)}
            disabled={disabled}
          >
            Join Team
          </Button>
        </div>
      </div>
      {errorMessage && (
        <Alert message={errorMessage} type="error" showIcon className="team-invitation-card__error-alert" />
      )}
    </div>
  );
}

TeamInvitationCard.propTypes = {
  team: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    teamManagerName: PropTypes.string,
    isFull: PropTypes.bool,
  }).isRequired,
  isJoined: PropTypes.bool.isRequired,
  onJoin: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  errorMessage: PropTypes.string,
};

TeamInvitationCard.defaultProps = {
  disabled: false,
  errorMessage: null,
};

export default TeamInvitationCard;
